import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from "@ionic/react";
import React from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebaseconfig.js";
import { useTranslation } from "react-i18next";
import "./Register.css";

const Register: React.FC = () => {
  const router = useIonRouter();

  const [t, i18n] = useTranslation("global");
  

  const doRegister = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const email = ((event.target as HTMLFormElement)[0] as HTMLInputElement)
      .value;
    const password = ((event.target as HTMLFormElement)[1] as HTMLInputElement)
      .value;

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      console.log("✅ Registro exitoso:", userCredential.user);
      router.push("/"); // Redirige al usuario
    } catch (error: any) {
      console.error("❌ Error al registrar:", error.message);
      alert(error.message);
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar className="Color-degradado">
          <IonButtons slot="start">
            <IonBackButton color={"light"} defaultHref="/"></IonBackButton>
          </IonButtons>
          <IonTitle></IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonTitle className="title ion-margin-bottom ion-margin-top ion-text-center">
          {t("register.registronuevos")}
        </IonTitle>
        <form onSubmit={doRegister}>
          <div className="margenH">
            <IonInput
              aria-label="Email"
              placeholder={t("login.placeholder-email")}
              fill="outline"
              labelPlacement="floating"
              label={t("login.title-email")}
              type="email"
              className="Inputs-login"
            ></IonInput>
          </div>
          <div className="margenH">
            <IonInput
              aria-label="Password"
              placeholder={t("login.placeholder-pass")}
              fill="outline"
              labelPlacement="floating"
              label={t("login.title-pass")}
              type="password"
              className="ion-margin-top ion-margin-bottom Inputs-login"
            ></IonInput>
          </div>
          <br></br>
          <IonButton
            expand="block"
            shape="round"
            size="default"
            className="botoncustom ion-text-capitalize"
            type="submit"
          >
            {t("register.button")}
          </IonButton>
        </form>
      </IonContent>
    </IonPage>
  );
};

export default Register;
